'use client';

import CircleInfoSvg from '@/assets/svgs/circle-info.svg';
import classNames from 'classnames';

interface InfoAlertProps {
  children: React.ReactNode;
  className?: string;
}

const InfoAlert = ({ children, className }: InfoAlertProps) => {
  return (
    <div
      role="alert"
      className={classNames(
        'flex items-center gap-3 rounded-md border border-blue-200 bg-blue-50 p-3 text-sm text-blue-700 dark:border-blue-900/40 dark:bg-blue-950/40 dark:text-blue-300',
        className
      )}>
      <CircleInfoSvg className="mt-0.5 h-6 w-6 flex-shrink-0 text-blue-700 dark:text-blue-300" />
      <div className="flex-1">{children}</div>
    </div>
  );
};

export default InfoAlert;
